import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getStudent, getRole, logout } from '../services/auth';

export default function Navbar() {
  const student  = getStudent();
  const role     = getRole();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const active = path => location.pathname === path ? 'nav-link active' : 'nav-link';
  const close  = () => setMenuOpen(false);

  const NAV_ITEMS = role === 'admin'
    ? [
        { to: '/admin',                       label: '📊 Summary'       },
        { to: '/admin?tab=referrals',         label: '🔗 Referrals'     },
        { to: '/admin?tab=rewards',           label: '💰 Rewards'       },
        { to: '/admin?tab=students',          label: '👥 Students'      },
        { to: '/admin?tab=councillors',       label: '🏛 Councillors'   },
        { to: '/admin?tab=users',             label: '👤 Manage Users'  },
        { to: '/contact',                     label: 'Contact'           },
      ]
    : role === 'councillor'
    ? [
        { to: '/view',                    label: 'Summary'       },
        { to: '/view?tab=referrals',      label: 'Referrals'     },
        { to: '/contact',                 label: 'Contact'       },
      ]
    : [
        { to: '/dashboard',     label: 'Dashboard' },
        { to: '/referrals',     label: 'My Referrals' },
        { to: '/rewards',       label: 'My Rewards' },
        { to: '/contact',       label: 'Contact' },
      ];

  return (
    <nav className="navbar">
      <Link to="/" className="nav-brand" style={{ textDecoration: 'none' }}>
        <img src="/uniglobal-logo.jpeg" alt="UNI GLOBAL" style={{ height: 36, width: 'auto', borderRadius: 6, background: '#fff', padding: '3px 8px' }} />
      </Link>

      {/* Desktop links */}
      {student ? (
        <div className="nav-links">
          {NAV_ITEMS.map(item => (
            <Link key={item.to} className={active(item.to)} to={item.to}>{item.label}</Link>
          ))}
        </div>
      ) : (
        <div className="nav-links">
          <Link className={active('/contact')} to="/contact">Contact</Link>
          <Link className={active('/login')} to="/login">Login</Link>
          <Link className={active('/register')} to="/register" style={{ background: 'linear-gradient(135deg,#4f46e5,#7c3aed)', color: '#fff', borderRadius: 8, padding: '.3rem .9rem', fontWeight: 700 }}>Register</Link>
        </div>
      )}

      {/* Desktop user */}
      {student && (
        <div className="nav-user nav-user-desktop">
          <span className="nav-greeting">Hi, {student.name.split(' ')[0]}</span>
          <button className="btn-logout" onClick={logout}>Logout</button>
        </div>
      )}

      {/* Mobile hamburger */}
      <button
        className="nav-hamburger"
        onClick={() => setMenuOpen(o => !o)}
        aria-label="Toggle menu"
      >
        <span className={`ham-line ${menuOpen ? 'open' : ''}`} />
        <span className={`ham-line ${menuOpen ? 'open' : ''}`} />
        <span className={`ham-line ${menuOpen ? 'open' : ''}`} />
      </button>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="nav-mobile-menu">
          {student && <div className="nav-mobile-greeting">Hi, {student.name.split(' ')[0]}</div>}
          {student ? NAV_ITEMS.map(item => (
            <Link
              key={item.to}
              className={`nav-mobile-link ${location.pathname === item.to ? 'active' : ''}`}
              to={item.to}
              onClick={close}
            >
              {item.label}
            </Link>
          )) : (<>
            <Link className={`nav-mobile-link ${location.pathname === '/contact' ? 'active' : ''}`} to="/contact" onClick={close}>Contact</Link>
            <Link className={`nav-mobile-link ${location.pathname === '/login' ? 'active' : ''}`} to="/login" onClick={close}>Login</Link>
            <Link className="nav-mobile-link nav-mobile-register" to="/register" onClick={close}>Register</Link>
          </>)}
          {student && (
            <button className="nav-mobile-logout" onClick={() => { close(); logout(); }}>
              Logout
            </button>
          )}
        </div>
      )}
    </nav>
  );
}
